/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

const Actions = {
  async addItemToCart(id) {
     const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id,
        quantity: 1
      })
    });
    const json = await res.json();
    console.log({ json })
  },
  
  renderCart() {
    Shopify.renderCart();
  }
}

const DrawerUpsellsApp = {
  init() {
    this.container = document.querySelector('#sidebar-cart');
    if (!this.container) return;
    this.setupEventListeners();
  },

  setupEventListeners() {
    this.container.onclick = this.handleContainerClick.bind(this);
  },

  disableButton(btn) {
    btn.disabled = true;
    btn.textContent = 'Adding...';
  },

  revertButton(btn, html) {
    btn.disabled = false;
    btn.innerHTML = html;   
  },

  async handleContainerClick(e) {
    if (!(e.target.matches('.Cart__Upsell-Button') || e.target.closest('.Cart__Upsell-Button'))) return;
    e.preventDefault();
    const btn = e.target.matches('.Cart__Upsell-Button') ? e.target : e.target.closest('.Cart__Upsell-Button');
    const originalHTML = btn.innerHTML;
    this.disableButton(btn);
    try {
      await Actions.addItemToCart(btn.dataset.id);
      await Actions.renderCart();    
    } catch (err) {
      alert(err);
    } finally {
      // renderCart actually negates the finally
      this.revertButton(btn, originalHTML);
    }
  }
  
}

DrawerUpsellsApp.init();
